
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { EAppIconsStandard, EAppIcons } from 'src/app/classes/def/app/icons';
import { IViewSpecs, ViewSpecs, INavParams } from 'src/app/classes/def/nav-params/general';
import { ParamHandler } from 'src/app/classes/general/params';
import { ShareService } from 'src/app/services/general/apis/share';
import { UiExtensionService } from 'src/app/services/general/ui/ui-extension';
import { IMediaUploadContext } from 'src/app/services/media/media-template';
import { MediaUtilsService } from 'src/app/services/media/media-utils';
import { VideoService } from 'src/app/services/media/video';

export interface IAVFrameNavParams {
  title: string;
  description?: string;
  context: IMediaUploadContext;
  videoUrl?: string;
}

@Component({
  selector: 'modal-av-recording-frame',
  templateUrl: './av-recording-frame.component.html',
  styleUrls: ['./av-recording-frame.component.scss'],
})
export class AvRecordingFrameComponent implements OnInit, OnDestroy {
  @ViewChild('avStream', { read: ElementRef, static: false }) avStream: ElementRef<HTMLVideoElement>;

  description: string = "";
  title: string = "";
  videoUrl: string = null;

  appIconsStandard = EAppIconsStandard;
  appIcons = EAppIcons;

  vs: IViewSpecs = ViewSpecs.getDefault();

  params: IAVFrameNavParams = null;

  np: INavParams = null;

  context: IMediaUploadContext;

  constructor(
    public modalCtrl: ModalController,
    public shareProvider: ShareService,
    public mediaUtils: MediaUtilsService,
    public video: VideoService,
    public uiext: UiExtensionService
  ) {

  }

  ngOnInit() {
    let hasParams: boolean = ParamHandler.checkParams(this.np);

    if (hasParams) {
      let np: INavParams = ParamHandler.getParams(this.np);
      let params: IAVFrameNavParams = np.params;
      this.params = params;

      if (np.view) {
        this.vs = np.view;
      }

      console.log(np);

      this.description = params.description;

      this.title = params.title;
      this.videoUrl = params.videoUrl;

      this.context = params.context;

      // if (this.videoUrl != null) {
      //   this.video.setVideoElementPlayable(this.avStream);
      // }
    }
  }

  ngOnDestroy() {

  }

  dismiss() {
    setTimeout(() => {
      this.modalCtrl.dismiss(null).then(() => {
      }).catch((err: Error) => {
        console.error(err);
      });
    }, 1);
  }
}

